<template>
  <router-link v-slot="{ href, navigate }" :to="to" custom><a :href="href" :aria-current="selected ? 'page' : null" @click="navigate"><slot /></a></router-link>
</template>
<script>
// A collection stays selected across its page/filter URLs. RouterLink's exact
// URL comparison would otherwise replace aria-current supplied by the caller.
export default { name: 'ForumNavLink', props: { to: { type: Object, required: true }, selected: Boolean } };
</script>
